module.exports = __webpack_public_path__ + "assets/img/theX-prize-01.f9f04a7e.jpg";